import AllRoutes from "./routes";

export default function App() {
  return <AllRoutes />;
}
